import { createEntityAdapter } from '@ngrx/entity';
import { SocieteConfigAnalyseSyntheseSocieteCaracteristiqueEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<SocieteConfigAnalyseSyntheseSocieteCaracteristiqueEntityState>;

export const adapter = createEntityAdapter<SocieteConfigAnalyseSyntheseSocieteCaracteristiqueEntityState>({
  selectId: o => o.idSocieteConfigAnalyseSyntheseSocieteCaracteristique
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const societeConfigAnalyseSyntheseSocieteCaracteristiqueFeatureKey = 'societeConfigAnalyseSyntheseSocieteCaracteristique';
